import React from 'react';
import Customer from 'components/Tvendo/Mobile/Customer/Customer';
export default function () {
  return <Customer />;
}
